import { Pipe, PipeTransform } from '@angular/core';

import { AuthService } from '../services/security/auth.service';
import { TranslatorService } from '../services/utils/translator.service';

@Pipe({ name: 'CanShowInfo' })
export class CanShowInfoPipe implements PipeTransform {

  constructor(
    private readonly translate: TranslatorService, private readonly authService: AuthService
  ) {
  }

  transform(stringForTranslate: string, rolesPermitted: string[], translateIfNoPermitted: string): string {

    return rolesPermitted.includes(this.authService.getUserRol()) ?
      this.translate.trans(stringForTranslate) :
      this.translate.trans(translateIfNoPermitted);
  }
}
